import { Action, createReducer, on } from '@ngrx/store'
import { FrontState } from 'libs/gb-front/core/data-access/src/'
import * as AuctionActions from './auction.actions'
import { AuctionEntity, CreditCardPreAuthEnum, TippingComponentEnum } from './auction.models'
import { MenuItemTypeEnum, LOGIN_REGISTER_CHECKIN_CHECKOUT_MENU_ITEMS, MenuItemEntity } from './menu-items.models'

export const AUCTION_FEATURE_KEY = 'auction'

export interface AuctionState extends AuctionEntity {
  loaded: boolean // has the Auction been loaded WOW
  showTippingMessage: boolean
  selectedPaymentMethodId?: string
}

export const initialState: AuctionState = {
  uuid: '',
  owner: '',
  charges_enabled: false,
  client_account: '',
  url_name: '',
  name: '',
  status: '',
  currency: '',
  start: undefined,
  end: undefined,
  timezone: '',
  target: 0,
  donation_target: 0,
  country: '',
  banners: [],
  show_banner_text: false,
  limit_banner_height: false,
  logo: undefined,
  primary_color: '',
  accent_color: '',
  background_color: '',
  warn_color: '',
  success_color: '',
  supported_sms_country_codes: [],
  banner_background_color: '',
  custom_css: '',
  show_banner_overlay: false,
  sms_service: '',
  sms_enabled: false,
  sms_notifications_enabled: false,
  payment_gateway: '',
  stripe_connect: null,
  stripe_user_id: '',
  stripe_publishable_key: '',
  capture_phone_numbers: '',
  capture_emails: '',
  capture_table_numbers: '',
  capture_addresses: '',
  capture_terms_and_conditions_agreement: false,
  capture_company_name: '',
  capture_company_address: '',
  default_tipping_fee_option: '',
  terms_and_conditions: '',
  invoice_bank_details: '',
  invoice_city: '',
  invoice_company_name: '',
  invoice_country: '',
  invoice_email: '',
  invoice_footer_message: '',
  invoice_more_information: '',
  invoice_phone: '',
  invoice_postcode: '',
  invoice_state: '',
  invoice_street_address: '',
  invoice_suburb: '',
  invoice_website: '',
  invoice_image: undefined,
  is_saas: false,
  is_single_item: false,
  credit_card_preauthorisation: CreditCardPreAuthEnum.Off,
  additional_info_required: false,
  homepage: '',
  homepage_hub: '',
  homepage_infobooth: '',
  gift_aid_enabled: false,
  has_raffle: false,
  allow_phone_registration: false,
  allow_email_registration: false,
  tipping_component: TippingComponentEnum.Dropdown,
  tipping_fee: 0,
  tipping_fee_enabled: false,
  tipping_fee_options: [],
  tipping_slider_amount_options: [],
  default_tipping_slider_amount_option: '',
  scheduled: false,
  scheduled_end: undefined,
  scheduled_start: undefined,
  scheduled_start_enabled: false,
  enable_scheduled_time_extend: false,
  scheduled_time_extend: 0,
  enable_end_auction_notification: false,
  enable_facebook_login: false,
  enable_google_login: false,
  closed_popup_message: '',
  closed_banner_message: '',
  paused_banner_message: '',
  include_ioc_total_raised: false,
  enable_activity_feed: false,
  enable_app_checkout_popup: false,
  trial_locked: false,
  single_item_uuid: '',
  first_ticket_package_uuid: '',
  item_count: 0,
  ticket_package_count: 0,
  enable_bid_activity_poppers: false,
  enable_donation_activity_poppers: false,
  enable_purchase_activity_poppers: false,
  enable_raffle_activity_poppers: false,
  sms_service_number: '',
  registration_custom_fields: [],
  application_version: undefined,
  loaded: false,
  enable_item_activity_feed: true,
  menu_items: [],
  taxes: [],
  payment_methods: [],
  categories: [],
  event_name: '',
  event_dates: [],
  event_location: {
    address: '',
  },
  unlimited_event_capacity: false,
  event_capacity: null,
  event_tickets_remaining: -1,
  tickets_label: '',
  enable_ticketing: false,
  event_ticket_preview_enabled: false,
  password_complexity_policy: null,
  commission_enabled: false,
  payment_donation_component: null,
  payment_donation_slider_amounts: [],
  payment_donation_button_amounts: [],
  showTippingMessage: true,
  selectedPaymentMethodId: '',
}

export interface State extends FrontState {
  [AUCTION_FEATURE_KEY]: AuctionState
}

export const AuctionReducer = createReducer(
  initialState,
  on(AuctionActions.loadAuctionSuccess, (state, auction) => ({
    ...state,
    ...auction.auction,
    error: '',
    loaded: true,
    menu_items: getMenuItems(auction.auction.menu_items),
  })),
  on(AuctionActions.setSelectedPaymentMethod, (state, { paymentMethodUuid }) => ({
    ...state,
    selectedPaymentMethodId: paymentMethodUuid,
  })),
  on(AuctionActions.clearSelectedPaymentMethod, (state) => ({
    ...state,
    selectedPaymentMethodId: initialState.selectedPaymentMethodId,
  })),
  on(AuctionActions.dismissTippingMessage, (state) => ({
    ...state,
    showTippingMessage: false,
  })),
)

export function reducer(state: AuctionState | undefined, action: Action) {
  return AuctionReducer(state, action)
}

export function getMenuItems(menuItems: MenuItemEntity[]) {
  // Default 'My account' order no
  let myAccountOrder = 4
  // Find 'My account' menu item in response
  const myAccountMenuItem = menuItems.find((item) => item.button_type === MenuItemTypeEnum.MyAccount)
  // Assign order of 'Login', 'Register' and 'Checkout' same as 'My account'
  if (myAccountMenuItem) myAccountOrder = myAccountMenuItem.order

  const newMenuItems = [...menuItems, ...LOGIN_REGISTER_CHECKIN_CHECKOUT_MENU_ITEMS(myAccountOrder)]

  return newMenuItems
}
